/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.behavior.incidents'},
});

const IncidentsItem = () => (
  <RouteLinkItem
    route="midas/settings/behavior/incidents"
    title={messages.title}
  />
);

export default IncidentsItem;
